<!-- Prijavna stran OKS – vizualni jezik povzet po olympic.si -->
<div class="oks-accent" aria-hidden="true"></div>

<main class="oks-main">

    <aside class="oks-brand">
        <div class="oks-brand__content">
            <a class="oks-brand__logo" href="https://olympic.si" target="_blank" rel="noopener noreferrer">
                <img src="/assets/project-custom/images/logo.png" alt="Olimpijski komite Slovenije" />
            </a>

            <p class="oks-brand__eyebrow">Olimpijski komite Slovenije</p>
            <h2 class="oks-brand__title">Portal za razpise in vloge</h2>
            <p class="oks-brand__lead">
                Oddajte vlogo na aktualne razpise, spremljajte potek obravnave in dostopajte do izdanih
                odločb — vse na enem mestu.
            </p>

            <ul class="oks-brand__list">
                <li>
                    <svg viewBox="0 0 20 20" aria-hidden="true" focusable="false">
                        <path d="M4 10.5l4 4 8-9"></path>
                    </svg>
                    <span>Elektronska oddaja vloge brez pošiljanja papirjev</span>
                </li>
                <li>
                    <svg viewBox="0 0 20 20" aria-hidden="true" focusable="false">
                        <path d="M4 10.5l4 4 8-9"></path>
                    </svg>
                    <span>Sproten vpogled v status obravnave</span>
                </li>
                <li>
                    <svg viewBox="0 0 20 20" aria-hidden="true" focusable="false">
                        <path d="M4 10.5l4 4 8-9"></path>
                    </svg>
                    <span>Varno shranjena dokumentacija in odločbe</span>
                </li>
            </ul>
        </div>

        <svg class="oks-brand__motif" viewBox="0 0 320 120" preserveAspectRatio="none" aria-hidden="true"
            focusable="false">
            <path d="M0 120 L60 20 L120 120 L180 20 L240 120 L300 20 L320 55 L320 120 Z" class="motif-green"></path>
            <path d="M160 120 L220 20 L280 120 L320 60 L320 120 Z" class="motif-blue"></path>
        </svg>
    </aside>

    <section class="oks-panel">

        <!-- PRIJAVA -->
        <div class="oks-card" *ngIf="!showRegistration && !showPasswordReset && !showActivation && !showNewPassword">

            <div class="oks-card__head">
                <h1>Prijava</h1>
                <p class="oks-card__sub">Vpišite se z e-poštnim naslovom in geslom.</p>
            </div>

            <div class="oks-alert oks-alert--error" role="alert" *ngIf="showAlertMessage">
                <svg viewBox="0 0 20 20" aria-hidden="true" focusable="false">
                    <circle cx="10" cy="10" r="8"></circle>
                    <path d="M10 6v5M10 13.6v.4"></path>
                </svg>
                <span>{{ alertMessage }}</span>
            </div>

            <form class="oks-form" #loginForm="ngForm" (ngSubmit)="loginClick()" novalidate>

                <div class="oks-field">
                    <label class="oks-label" for="loginUsername">E-poštni naslov</label>
                    <input id="loginUsername" class="oks-input" [(ngModel)]="username" name="username" type="email"
                        autocomplete="username" inputmode="email" placeholder="ime.priimek&#64;primer.si" />
                </div>

                <div class="oks-field">
                    <div class="oks-label-row">
                        <label class="oks-label" for="Password">Geslo</label>
                        <button type="button" class="oks-link oks-link--sm" (click)="showPasswordResetView()">
                            Pozabljeno geslo
                        </button>
                    </div>
                    <div class="oks-input-wrap">
                        <input id="Password" class="oks-input oks-input--action" [(ngModel)]="password" name="password"
                            [type]="visiblePasswords['login'] ? 'text' : 'password'" autocomplete="current-password"
                            placeholder="Vpišite geslo" />
                        <button type="button" class="oks-reveal" (click)="togglePassword('login')"
                            [class.oks-reveal--on]="visiblePasswords['login']"
                            [attr.aria-pressed]="!!visiblePasswords['login']"
                            [attr.aria-label]="visiblePasswords['login'] ? 'Skrij geslo' : 'Pokaži geslo'">
                            <svg viewBox="0 0 20 20" aria-hidden="true" focusable="false">
                                <path d="M1.5 10S4.6 4.5 10 4.5 18.5 10 18.5 10 15.4 15.5 10 15.5 1.5 10 1.5 10Z"></path>
                                <circle cx="10" cy="10" r="2.6"></circle>
                                <path class="oks-reveal__slash" d="M3 17 17 3"></path>
                            </svg>
                        </button>
                    </div>
                </div>

                <button class="oks-btn oks-btn--primary" type="submit" [disabled]="disabled">
                    <span class="oks-spinner" *ngIf="disabled" aria-hidden="true"></span>
                    <span>{{ disabled ? 'Prijavljanje…' : 'Prijava' }}</span>
                </button>
            </form>

            <div class="oks-divider"><span>ali</span></div>

            <p class="oks-card__foot">
                Nimate računa?
                <button type="button" class="oks-link" (click)="showRegistrationView()">Registracija</button>
            </p>
        </div>

        <!-- REGISTRACIJA -->
        <div class="oks-card" *ngIf="showRegistration">

            <div class="oks-card__head">
                <h1>Registracija</h1>
                <p class="oks-card__sub">Ustvarite račun za oddajo vloge na razpise OKS.</p>
            </div>

            <div class="oks-alert oks-alert--error" role="alert" *ngIf="showAlertMessage">
                <svg viewBox="0 0 20 20" aria-hidden="true" focusable="false">
                    <circle cx="10" cy="10" r="8"></circle>
                    <path d="M10 6v5M10 13.6v.4"></path>
                </svg>
                <span>{{ alertMessage }}</span>
            </div>

            <div class="oks-alert oks-alert--success" role="status" *ngIf="successMessage">
                <svg viewBox="0 0 20 20" aria-hidden="true" focusable="false">
                    <path d="M4 10.5l4 4 8-9"></path>
                </svg>
                <span>{{ successMessage }}</span>
            </div>

            <form class="oks-form" #registrationForm="ngForm" (ngSubmit)="registrationClick()" novalidate
                *ngIf="!regSuccess">

                <div class="oks-field">
                    <label class="oks-label" for="regName">Ime in priimek</label>
                    <input id="regName" class="oks-input" [(ngModel)]="registrationName" name="regusername" required
                        [ngClass]="{'oks-input--error': registrationSubmitted && regusername.errors}" autocomplete="name"
                        #name="ngModel" #regusername="ngModel" placeholder="Ime in priimek" type="text"
                        [attr.aria-invalid]="registrationSubmitted && !!regusername.errors" />
                    <p class="oks-error" *ngIf="registrationSubmitted && regusername.errors?.['required']">
                        Polje je obvezno.
                    </p>
                </div>

                <div class="oks-field">
                    <label class="oks-label" for="RegIPassword">E-poštni naslov</label>
                    <input id="RegIPassword" class="oks-input" [(ngModel)]="registrationEmail" name="regemail" required
                        [ngClass]="{'oks-input--error': registrationSubmitted && regemail.errors}" autocomplete="email"
                        inputmode="email" #regemail="ngModel" placeholder="ime.priimek&#64;primer.si" type="email" email
                        [attr.aria-invalid]="registrationSubmitted && !!regemail.errors" />
                    <p class="oks-error" *ngIf="registrationSubmitted && regemail.errors?.['required']">
                        Polje je obvezno.
                    </p>
                    <p class="oks-error" *ngIf="registrationSubmitted && regemail.errors?.['email']">
                        Neveljaven e-poštni naslov.
                    </p>
                </div>

                <div class="oks-field">
                    <label class="oks-label" for="regPassword">Geslo</label>
                    <div class="oks-input-wrap">
                        <input id="regPassword" class="oks-input oks-input--action" [(ngModel)]="registrationPassword"
                            name="regpassword" required
                            [ngClass]="{'oks-input--error': registrationSubmitted && regpassword.errors}"
                            autocomplete="new-password" #regpassword="ngModel" placeholder="Vpišite geslo"
                            [type]="visiblePasswords['reg'] ? 'text' : 'password'"
                            [attr.aria-invalid]="registrationSubmitted && !!regpassword.errors" />
                        <button type="button" class="oks-reveal" (click)="togglePassword('reg')"
                            [class.oks-reveal--on]="visiblePasswords['reg']"
                            [attr.aria-pressed]="!!visiblePasswords['reg']"
                            [attr.aria-label]="visiblePasswords['reg'] ? 'Skrij geslo' : 'Pokaži geslo'">
                            <svg viewBox="0 0 20 20" aria-hidden="true" focusable="false">
                                <path d="M1.5 10S4.6 4.5 10 4.5 18.5 10 18.5 10 15.4 15.5 10 15.5 1.5 10 1.5 10Z"></path>
                                <circle cx="10" cy="10" r="2.6"></circle>
                                <path class="oks-reveal__slash" d="M3 17 17 3"></path>
                            </svg>
                        </button>
                    </div>
                    <p class="oks-error" *ngIf="registrationSubmitted && regpassword.errors?.['required']">
                        Polje je obvezno.
                    </p>
                </div>

                <div class="oks-field">
                    <label class="oks-label" for="RegIPasswordR">Ponovite geslo</label>
                    <div class="oks-input-wrap">
                        <input id="RegIPasswordR" class="oks-input oks-input--action"
                            [(ngModel)]="registrationPasswordRepeat" name="regpasswordrepeat" required
                            [ngClass]="{'oks-input--error': registrationSubmitted && regPasswordRepeat.errors}"
                            autocomplete="new-password" #regPasswordRepeat="ngModel" placeholder="Ponovite geslo"
                            [type]="visiblePasswords['regRepeat'] ? 'text' : 'password'"
                            [attr.aria-invalid]="registrationSubmitted && !!regPasswordRepeat.errors" />
                        <button type="button" class="oks-reveal" (click)="togglePassword('regRepeat')"
                            [class.oks-reveal--on]="visiblePasswords['regRepeat']"
                            [attr.aria-pressed]="!!visiblePasswords['regRepeat']"
                            [attr.aria-label]="visiblePasswords['regRepeat'] ? 'Skrij geslo' : 'Pokaži geslo'">
                            <svg viewBox="0 0 20 20" aria-hidden="true" focusable="false">
                                <path d="M1.5 10S4.6 4.5 10 4.5 18.5 10 18.5 10 15.4 15.5 10 15.5 1.5 10 1.5 10Z"></path>
                                <circle cx="10" cy="10" r="2.6"></circle>
                                <path class="oks-reveal__slash" d="M3 17 17 3"></path>
                            </svg>
                        </button>
                    </div>
                    <p class="oks-error" *ngIf="registrationSubmitted && regPasswordRepeat.errors?.['required']">
                        Polje je obvezno.
                    </p>
                </div>

                <button class="oks-btn oks-btn--primary" type="submit" [disabled]="regInProcess">
                    <span class="oks-spinner" *ngIf="regInProcess" aria-hidden="true"></span>
                    <span>{{ regInProcess ? 'Registriranje…' : 'Registracija' }}</span>
                </button>
            </form>

            <p class="oks-card__foot" *ngIf="!regInProcess">
                <button type="button" class="oks-link" (click)="clear()">Nazaj na prijavo</button>
            </p>
        </div>

        <!-- NOVO GESLO (povezava iz e-pošte) -->
        <div class="oks-card" *ngIf="showNewPassword">

            <div class="oks-card__head">
                <h1>Novo geslo</h1>
                <p class="oks-card__sub">Vpišite novo geslo za dostop do portala.</p>
            </div>

            <div class="oks-alert oks-alert--error" role="alert" *ngIf="showAlertMessage">
                <svg viewBox="0 0 20 20" aria-hidden="true" focusable="false">
                    <circle cx="10" cy="10" r="8"></circle>
                    <path d="M10 6v5M10 13.6v.4"></path>
                </svg>
                <span>{{ alertMessage }}</span>
            </div>

            <div class="oks-alert oks-alert--success" role="status" *ngIf="successMessage">
                <svg viewBox="0 0 20 20" aria-hidden="true" focusable="false">
                    <path d="M4 10.5l4 4 8-9"></path>
                </svg>
                <span>{{ successMessage }}</span>
            </div>

            <form class="oks-form" #passwordResetForm="ngForm" (ngSubmit)="sendPasswordResetValues()" novalidate
                *ngIf="!newPasswordResetSuccess">

                <div class="oks-field">
                    <label class="oks-label" for="newPassword">Novo geslo</label>
                    <div class="oks-input-wrap">
                        <input id="newPassword" class="oks-input oks-input--action" [(ngModel)]="registrationPassword"
                            name="regpassword" required
                            [ngClass]="{'oks-input--error': registrationSubmitted && regpassword.errors}"
                            autocomplete="new-password" #regpassword="ngModel" placeholder="Vpišite novo geslo"
                            [type]="visiblePasswords['new'] ? 'text' : 'password'"
                            [attr.aria-invalid]="registrationSubmitted && !!regpassword.errors" />
                        <button type="button" class="oks-reveal" (click)="togglePassword('new')"
                            [class.oks-reveal--on]="visiblePasswords['new']"
                            [attr.aria-pressed]="!!visiblePasswords['new']"
                            [attr.aria-label]="visiblePasswords['new'] ? 'Skrij geslo' : 'Pokaži geslo'">
                            <svg viewBox="0 0 20 20" aria-hidden="true" focusable="false">
                                <path d="M1.5 10S4.6 4.5 10 4.5 18.5 10 18.5 10 15.4 15.5 10 15.5 1.5 10 1.5 10Z"></path>
                                <circle cx="10" cy="10" r="2.6"></circle>
                                <path class="oks-reveal__slash" d="M3 17 17 3"></path>
                            </svg>
                        </button>
                    </div>
                    <p class="oks-error" *ngIf="registrationSubmitted && regpassword.errors?.['required']">
                        Polje je obvezno.
                    </p>
                </div>

                <div class="oks-field">
                    <label class="oks-label" for="RegIPasswordR">Ponovite novo geslo</label>
                    <div class="oks-input-wrap">
                        <input id="RegIPasswordR" class="oks-input oks-input--action"
                            [(ngModel)]="registrationPasswordRepeat" name="regpasswordrepeat" required
                            [ngClass]="{'oks-input--error': registrationSubmitted && regPasswordRepeat.errors}"
                            autocomplete="new-password" #regPasswordRepeat="ngModel" placeholder="Ponovite novo geslo"
                            [type]="visiblePasswords['newRepeat'] ? 'text' : 'password'"
                            [attr.aria-invalid]="registrationSubmitted && !!regPasswordRepeat.errors" />
                        <button type="button" class="oks-reveal" (click)="togglePassword('newRepeat')"
                            [class.oks-reveal--on]="visiblePasswords['newRepeat']"
                            [attr.aria-pressed]="!!visiblePasswords['newRepeat']"
                            [attr.aria-label]="visiblePasswords['newRepeat'] ? 'Skrij geslo' : 'Pokaži geslo'">
                            <svg viewBox="0 0 20 20" aria-hidden="true" focusable="false">
                                <path d="M1.5 10S4.6 4.5 10 4.5 18.5 10 18.5 10 15.4 15.5 10 15.5 1.5 10 1.5 10Z"></path>
                                <circle cx="10" cy="10" r="2.6"></circle>
                                <path class="oks-reveal__slash" d="M3 17 17 3"></path>
                            </svg>
                        </button>
                    </div>
                    <p class="oks-error" *ngIf="registrationSubmitted && regPasswordRepeat.errors?.['required']">
                        Polje je obvezno.
                    </p>
                </div>

                <button class="oks-btn oks-btn--primary" type="submit" [disabled]="newPasswordResetInProgress">
                    <span class="oks-spinner" *ngIf="newPasswordResetInProgress" aria-hidden="true"></span>
                    <span>{{ newPasswordResetInProgress ? 'Ponastavljanje…' : 'Ponastavi geslo' }}</span>
                </button>
            </form>

            <p class="oks-card__foot" *ngIf="newPasswordResetSuccess">
                <button type="button" class="oks-link" (click)="clear()">Nazaj na prijavo</button>
            </p>
        </div>

        <!-- POZABLJENO GESLO -->
        <div class="oks-card" *ngIf="showPasswordReset">

            <div class="oks-card__head">
                <h1>Pozabljeno geslo</h1>
                <p class="oks-card__sub" *ngIf="!resetSuccess">
                    Vpišite elektronski naslov, s katerim ste registrirani. Nanj boste prejeli povezavo za spremembo
                    gesla.
                </p>
            </div>

            <div class="oks-alert oks-alert--error" role="alert" *ngIf="showAlertMessage">
                <svg viewBox="0 0 20 20" aria-hidden="true" focusable="false">
                    <circle cx="10" cy="10" r="8"></circle>
                    <path d="M10 6v5M10 13.6v.4"></path>
                </svg>
                <span>{{ alertMessage }}</span>
            </div>

            <div class="oks-alert oks-alert--success" role="status" *ngIf="successMessage">
                <svg viewBox="0 0 20 20" aria-hidden="true" focusable="false">
                    <path d="M4 10.5l4 4 8-9"></path>
                </svg>
                <span>{{ successMessage }}</span>
            </div>

            <form class="oks-form" #passwordResetForm="ngForm" (ngSubmit)="sendMailForgotPassword()" novalidate
                *ngIf="!resetSuccess">

                <div class="oks-field">
                    <label class="oks-label" for="forgotPasswordMail">E-poštni naslov</label>
                    <input id="forgotPasswordMail" class="oks-input" [(ngModel)]="forgotPasswordMail"
                        name="forgotPasswordMail" type="email" autocomplete="email" inputmode="email"
                        placeholder="ime.priimek&#64;primer.si" />
                </div>

                <button class="oks-btn oks-btn--primary" type="submit" [disabled]="resetInProcess">
                    <span class="oks-spinner" *ngIf="resetInProcess" aria-hidden="true"></span>
                    <span>{{ resetInProcess ? 'Pošiljanje…' : 'Pošlji povezavo' }}</span>
                </button>
            </form>

            <p class="oks-card__foot" *ngIf="!resetInProcess">
                <button type="button" class="oks-link" (click)="clear()">Nazaj na prijavo</button>
            </p>
        </div>

        <!-- AKTIVACIJA -->
        <div class="oks-card" *ngIf="showActivation">

            <div class="oks-card__head">
                <h1>Aktivacija uporabnika</h1>
                <p class="oks-card__sub" *ngIf="activationInProgress">Preverjamo vašo aktivacijsko povezavo…</p>
            </div>

            <div class="oks-alert oks-alert--error" role="alert" *ngIf="showAlertMessage">
                <svg viewBox="0 0 20 20" aria-hidden="true" focusable="false">
                    <circle cx="10" cy="10" r="8"></circle>
                    <path d="M10 6v5M10 13.6v.4"></path>
                </svg>
                <span>{{ alertMessage }}</span>
            </div>

            <div class="oks-alert oks-alert--success" role="status" *ngIf="successMessage">
                <svg viewBox="0 0 20 20" aria-hidden="true" focusable="false">
                    <path d="M4 10.5l4 4 8-9"></path>
                </svg>
                <span>{{ successMessage }}</span>
            </div>

            <div class="oks-loading" *ngIf="activationInProgress">
                <span class="oks-spinner oks-spinner--dark" aria-hidden="true"></span>
                <span>Prosimo, počakajte…</span>
            </div>

            <p class="oks-card__foot" *ngIf="!activationInProgress && (activationSuccess || showLoginBtn)">
                <button type="button" class="oks-link" (click)="clear()">Nazaj na prijavo</button>
            </p>
        </div>

    </section>
</main>

<footer class="oks-footer">
    <div class="oks-footer__org">
        <p class="oks-footer__name">Olimpijski komite Slovenije – Združenje športnih zvez</p>
        <p>Ameriška ulica 2, 1000 Ljubljana</p>
    </div>

    <div class="oks-footer__contact">
        <a href="mailto:stipendije&#64;olympic.si">stipendije&#64;olympic.si</a>
        <a href="tel:012306014">012306014</a>
    </div>

    <p class="oks-footer__copy">© {{ currentYear }} Olimpijski komite Slovenije. Vse pravice pridržane.</p>
</footer>
